import React from 'react'
import Modal, { Header } from 'src/components/theme/Models/Modal'
import FormSuspense from 'src/components/Forms/FormSuspense'
import FormContext from './FormContext'
import Form from './Form'

interface EditModelProps {
  id: number
  isOpen: boolean
  toggle: () => void
}

const EditModel: React.FC<EditModelProps> = (props) => {
  const { id, isOpen, toggle } = props

  return (
    <Modal
      title='Edit Position Notes'
      isOpen={isOpen}
      toggle={toggle}
      size='lg'
    >
      <Header title='Edit Position Notes' />
      <FormSuspense fallback={<Form toggle={toggle} disableSave />}>
        <FormContext id={id} toggle={toggle} />
      </FormSuspense>
    </Modal>
  )
}

export default EditModel
